"use strict";

module.exports = require("./bundle.js");
